import React from 'react';
import AuthCallback from '../components/Auth/AuthCallback';

const AuthCallbackPage: React.FC = () => {
  return <AuthCallback />;
};

export default AuthCallbackPage; 